/**
 * window.Drupal.t polyfill
 * @param str
 */
if (!window.Drupal) {
  window.Drupal = {
    t: (str) => str,
  };
}

const PhonebookTranslate = {
  services: {
    button_display_more: window.Drupal.t('phonebook: Afficher plus'),
  },
};

export default PhonebookTranslate;
